import React from 'react';
import { useState } from 'react';
import { postLogin } from '../api/loginApi';
import { useNavigate } from 'react-router-dom';

export function Login() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const onSubmit = (e) => {
    if (username.length > 0 && password.length > 0) {
      postLogin(username, password)
        .then(() => {
          navigate('/home');
        })
        .catch(() => {
          setError(true);
        });
    } else {
      setError(true);
    }
    e.preventDefault();
  };

  return (
    <>
      <h2 className="column-flex align-center">ALO INC - Login Page</h2>
      <div className="column-flex align-center">
        <form>
          <div className="column-flex align-center">
            <label>
              Username:
              <input
                onInput={(e) => {
                  setUsername(e.target.value);
                }}
                type="text"
                name="username"
              />
            </label>
            <br />
            <label>
              Password:
              <input
                onInput={(e) => {
                  setPassword(e.target.value);
                }}
                type="password"
                name="password"
              />
            </label>
            <br />
            <div className="row-flex">
              <button type="submit" onClick={onSubmit}>
                Login
              </button>
              <button type="button" onClick={() => navigate('/signup')}>
                Signup
              </button>
            </div>
          </div>
        </form>
      </div>
      <div>
        {error && (
          <p style={{ color: 'red' }} className="column-flex align-center">
            You are a retard
          </p>
        )}
      </div>
    </>
  );
}
